import { Component } from '@angular/core';

@Component({
  selector: 'app-svg-mail',
  styleUrls: ['./mail.component.scss'],
  templateUrl: './mail.component.html'
})
export class MailComponent {}
